/**
 * Sticky PDP – Visibility + Add to Cart click proxy
 *
 * What it does:
 * - Watches the main PDP Add to Cart button visibility on scroll.
 * - When the main button is NOT visible in the viewport, it shows any sticky bar(s)
 *   by adding the class: `.is-visible` to each `.pdp-sticky`.
 * - When the main button IS visible, it hides sticky bar(s) by removing `.is-visible`.
 * - When the user clicks the sticky button, it simulates a click on the main PDP
 *   Add to Cart button (so it uses the theme's existing add-to-cart logic).
 *
 * Where it's used:
 * - Included in the Sticky PDP section/snippet on the PDP template(s) where the sticky exists.
 *
 * Dependencies / Notes:
 * - Requires a PDP add button with selector: button[type='submit'][name='add']
 * - Requires sticky wrappers with class: `.pdp-sticky`
 * - Requires CSS to handle `.pdp-sticky` + `.is-visible` transitions/visibility.
 */

document.addEventListener("DOMContentLoaded", function () {
  const mainBtn = document.querySelector("button[type='submit'][name='add']");
  const stickies = document.querySelectorAll(".pdp-sticky");

  if (!mainBtn || !stickies.length) return;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  }

  function toggleSticky() {
    const visible = isInViewport(mainBtn);

    stickies.forEach(function (sticky) {
      if (!visible) {
        sticky.classList.add("is-visible");
      } else {
        sticky.classList.remove("is-visible");
      }
    });
  }

  stickies.forEach(function (sticky) {
    const cta = sticky.querySelector("button");
    if (cta) {
      cta.addEventListener("click", function () {
        mainBtn.click();
      });
    }
  });

  window.addEventListener("scroll", toggleSticky);
  toggleSticky();
});
